import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";

import address from "./modules/address-module";
import alerts from "./modules/alerts-module";
import auth from "./modules/auth";
import banner from "./modules/banner-module";
import brand from "./modules/brand-module";
import budget from "./modules/budget-module";
import customer from "./modules/customer-module";
import external_apis from "./modules/external-apis-module";
import kit_editor from "./modules/kit-editor-module";
import inverter from "./modules/inverter-module";
import module from "./modules/module-module";
import shipping from "./modules/shipping-module";
import size from "./modules/size-module";
import string_sizer from "./modules/string-sizer-module";
import structure from "./modules/structure-module";
import structure_type from "./modules/structure-type-module";
import roles from "./modules/roles-module";
import order from "./modules/order-module";
import other_products from "./modules/other-products-module";
import permissions from "./modules/permission-module";
import product from "./modules/product-module";
import product_category from "./modules/product-category-module";
import provider from "./modules/provider-module";
import user from "./modules/user-module";
import message_board from "./modules/message-board-module";
import metrics from "./modules/metrics-module";


Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState()],
  modules: {
    address,
    alerts,
    auth,
    banner,
    brand,
    budget,
    customer,
    external_apis,
    kit_editor,
    inverter,
    module,
    shipping,
    size,
    string_sizer,
    structure,
    structure_type,
    roles,
    order,
    other_products,
    permissions,
    product,
    product_category,
    provider,
    user,
    message_board,
    metrics
  }
});
